// extracted by mini-css-extract-plugin
var _1 = "pfx-CommunityProjectsSection-module__create-project-btn--vIJhq";
export { _1 as "createProjectBtn" }
